module.exports = __webpack_public_path__ + "static/media/medical-savings-peter.4d7ab844.webp";